/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const CheckAll = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		className="pum-icon pum-icon--check-all"
	>
		<Path
			d="M8.01251 18.0001C7.74731 18.0001 7.493 17.8947 7.30551 17.7071L4.30551 14.7071C4.11468 14.5229 4.00484 14.2705 4.00016 14.0053C3.99547 13.7401 4.09631 13.4839 4.28051 13.2931C4.4647 13.1023 4.71715 12.9925 4.98233 12.9878C5.2475 12.9831 5.50368 13.0839 5.69451 13.2681L5.71951 13.2931L7.89151 15.4661L15.2035 5.41212C15.3595 5.19756 15.5942 5.05373 15.8562 5.01229C16.1182 4.97084 16.3859 5.03517 16.6005 5.19112C16.8151 5.34706 16.9589 5.58186 17.0003 5.84385C17.0418 6.10583 16.9775 6.37356 16.8215 6.58812L8.82151 17.5881C8.73678 17.7056 8.62753 17.8034 8.50131 17.8745C8.37509 17.9456 8.23492 17.9885 8.09051 18.0001H8.01251Z"
			fill="#000000"
		/>
		<Path
			d="M19.5125 8.00012H17.5125C17.2364 8.00012 17.0125 8.22398 17.0125 8.50012V9.50012C17.0125 9.77626 17.2364 10.0001 17.5125 10.0001H19.5125C19.7887 10.0001 20.0125 9.77626 20.0125 9.50012V8.50012C20.0125 8.22398 19.7887 8.00012 19.5125 8.00012Z"
			fill="#000000"
		/>
		<Path
			d="M19.5125 12.0001H14.5125C14.2364 12.0001 14.0125 12.224 14.0125 12.5001V13.5001C14.0125 13.7763 14.2364 14.0001 14.5125 14.0001H19.5125C19.7887 14.0001 20.0125 13.7763 20.0125 13.5001V12.5001C20.0125 12.224 19.7887 12.0001 19.5125 12.0001Z"
			fill="#000000"
		/>
		<Path
			d="M19.5125 16.0001H11.5125C11.2364 16.0001 11.0125 16.224 11.0125 16.5001V17.5001C11.0125 17.7763 11.2364 18.0001 11.5125 18.0001H19.5125C19.7887 18.0001 20.0125 17.7763 20.0125 17.5001V16.5001C20.0125 16.224 19.7887 16.0001 19.5125 16.0001Z"
			fill="#000000"
		/>
	</SVG>
);

export default CheckAll;
